var _a;
const accessibility = ((_a = window.otto) == null ? void 0 : _a.ally) ?? {};
const srSpeak = accessibility.srSpeak;
export {
  accessibility,
  srSpeak
};
/*                                            */
